export const randomId = (): string => Math.random().toString(32).slice(2, 10)

export default randomId
